<template>
  <section class="form-list">
    <el-form
      class="form form-large"
      ref="form"
      :rules="rules"
      :model="video"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="视频名称" prop="title">
        <el-input
          v-model="video.title"
          maxlength="32"
          show-word-limit
          clearable
          placeholder="请输入视频名称"
        />
      </el-form-item>

      <el-form-item label="视频分类" prop="video_sort_ids">
        <v-select-video-sort class="w100" v-model="video.video_sort_ids" :multiple="true"/>
      </el-form-item>

      <el-form-item label="所属课程" prop="course_ids">
        <v-select-course class="w100" v-model="video.course_ids" :multiple="true" @change="handleCourseChange"/>
      </el-form-item>

      <el-form-item label="视频老师" prop="course_ids">
        <v-select-teacher class="w100" v-model="video.teacher_ids" :clearable="true" :multiple="true" :remote="true" :list="teachers"/>
      </el-form-item>

      <el-form-item label="视频学员" prop="student_id">
        <v-select-student class="w100" v-model="video.student_ids" :clearable="true" :multiple="true" :list="students"/>
      </el-form-item>

      <v-image-upload
        v-model="video.cover"
        label="视频封面"
        prefix="video-cover"
        ratio="16:9"
        prop-name="cover"
      />

      <v-video-upload
        label="视频文件"
        prefix="video"
        prop-name="raw_src"
        v-model="video.raw_src"
        :src="video.src"
        @srcChange="src => video.src = src"
      />

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.videoList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { store } from '@/api/video';
  import { getDancersByCourseIds } from '@/api/course';
  import { videoStates } from "@/enums/videoStates";

  export default {
    name: RouteConfig.videoAdd.name,
    data: () => ({
      RouteConfig,
      isSaving: false,
      teachers: [],
      students: [],
      video: {
        title: '',
        video_sort_ids: [],
        course_ids: [],
        teacher_ids: [],
        student_ids: [],
        cover: '',
        raw_src: '',
        src: '',
        status: videoStates.published.value,
      },
      rules: {
        title: [{ required: true, message: '请输入封面名称', trigger: 'change' }],
        video_sort_ids: [{ required: true, message: '请选择视频分类', trigger: 'change' }],
        cover: [{ required: true, message: '请上传视频封面', trigger: 'change' }],
        raw_src: [{ required: true, message: '请上传视频文件', trigger: 'change' }],
      },
    }),
    methods: {
      async handleCourseChange(course_ids) {
        if (!course_ids.length) return;

        const { isError, data } = await getDancersByCourseIds(course_ids);
        if (isError) return;

        Object.assign(this, {
          teachers: data.teachers || [],
          students: data.students || [],
        });

        Object.assign(this.video, {
          teacher_ids: data.teacher_ids || [],
          student_ids: data.student_ids || [],
        });
      },
      handleSubmit() {
        if (this.isSaving) return;

        this.$refs.form.validate(async (isSuccess) => {
          if (!isSuccess) return;

          this.isSaving = true;
          const postData = { ...this.video };
          const { isError } = await store(postData);
          this.isSaving = false;
          if (!isError) RouteConfig.videoList.push();
        });
      },
    },
  };
</script>
